import {
  JournalCompany_company_staffs as Staff,
  JournalCompany_company_items as Item,
  JournalCompany_company_venues_tables as Table,
} from './__queries__';

export const buildSearchableTableEvents = (eventList: any[], staff: Staff[], tables: Table[]) => {
  return eventList.map((event: any) => {
    const staffName = staff?.find((s) => s.id === event.staffId)?.name;
    const tableCode = tables?.find((t) => t.id === event.tableId)?.code;
    const eventName = event?.type?.replace('_', ' ');

    return {
      ...event,
      staffName,
      tableName: `Table ${tableCode}`,
      itemName: event.title,
      eventName,
    };
  });
};

export const prettifyString = (str = ''): string => {
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word[0]?.toUpperCase() + word.slice(1))
    .join(' ');
};

export const buildSearchableReportEvents = (eventList: any[] = []) => {
  return eventList.map((event) => {
    const client = prettifyString(event?.clientId);
    const action = prettifyString(event.type);
    return { ...event, action, client };
  });
};
